import type { Didomi } from '$lib/services/tracking/googleAnalytics/type';
import { browser } from '$app/environment';

// SDK API: https://developers.didomi.io/cmp/web-sdk/reference/api
// Be careful to not use SDK Deprecated API (https://developers.didomi.io/cmp/web-sdk/reference/api/deprecated)

export function handleVendorConsent(vendorAppId: string, enableVendor: () => void, disableVendor?: () => void) {
	if (!browser) {
		return;
	}
	window.didomiOnReady?.push((didomi: Didomi) => {
		const userStatus = didomi.getCurrentUserStatus();

		const userVendor = userStatus.vendors[vendorAppId];

		// Apply current state immediately
		if (userVendor?.enabled) {
			enableVendor();
		} else if (userVendor) {
			disableVendor?.();
		} else if (userStatus.regulation !== 'gdpr') {
			// Consent not required
			enableVendor();
		}

		// Listen for future changes when GDPR applies
		if (userStatus.regulation === 'gdpr') {
			didomi.addVendorStatusListener(vendorAppId, (vendor) => {
				if (vendor.enabled) {
					enableVendor();
				} else {
					disableVendor?.();
				}
			});
		}
	});
}

export function createCheckConsentForVendor(vendorId: string) {
	return () => {
		if (browser && typeof window.Didomi?.getUserConsentStatusForVendor === 'function') {
			return window.Didomi.getUserConsentStatusForVendor(vendorId);
		}
		return false;
	};
}

export function showElementAfterDidomiModal(callback: () => void) {
	if (browser) {
		window.didomiOnReady = window.didomiOnReady || [];
		window.didomiOnReady.push(() => {
			window.Didomi?.once('notice.hidden', callback);
		});
	}
}
